<template>
  <div class="common-box">
    <el-form inline ref="form" class="search-form common-box-search-form" label-position="right" :model="form"
      label-width="120px">
      <search-form @search="handleSearch" @refresh="handleRefresh">
        <div slot="content">
          <el-form-item label="应收单据号：">
            <el-input @change="handleSearchListData" size="mini" v-model.trim="form.payableNo" placeholder="请输入应付单据号"
              clearable></el-input>
          </el-form-item>
          <el-form-item label="单据时间：">
            <el-date-picker v-model="form.createTimeBetween" @change="handleSearchListData" size="mini" type="daterange"
              range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss"
              unlink-panels clearable></el-date-picker>
          </el-form-item>
          <el-form-item label="确认收款时间：">
            <el-date-picker v-model="form.passTimeBetween" @change="handleSearchListData" size="mini" type="daterange"
              range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss"
              unlink-panels clearable></el-date-picker>
          </el-form-item>
          <el-form-item label="最近收款时间：">
            <el-date-picker v-model="form.lastPassTimeBetween" @change="handleSearchListData" size="mini" type="daterange"
              range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss"
              unlink-panels clearable></el-date-picker>
          </el-form-item>
          <el-form-item label="应收类型：" prop="type">
            <el-select size="mini" v-model="form.type" filterable placeholder="请选择支出项" clearable
              @change="handleSearchListData">
              <el-option v-for="item in receiveTypeList" :key="item.code" :label="item.name"
                :value="item.code"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="维修员:" prop="repairUserId">
            <el-select size="mini" v-model="form.repairUserId" filterable placeholder="请选择维修员" clearable
              @change="handleSearchListData">
              <el-option v-for="item in userList" :key="item.userId" :label="item.nickname"
                :value="item.userId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户：" prop="propertyUnit">
            <el-input @change="handleSearchListData" size="mini" v-model.trim="form.propertyUnitName"
              placeholder="请输入客户" clearable></el-input>
            </el-select>
          </el-form-item>
          <el-form-item label="关联单据号：">
            <el-input @change="handleSearchListData" size="mini" v-model.trim="form.sourceCode" placeholder="请输入关联单据号"
              clearable></el-input>
          </el-form-item>
       <!--   <el-form-item label="客户:" prop="propertyUnit">
            <el-select size="mini" v-model="form.propertyUnitId" filterable placeholder="请选择客户" clearable
              @change="handleSearchListData">
              <el-option v-for="item in propertyUnitSimpleList" :key="item.id" :label="item.unitName"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item> -->
        </div>
      </search-form>
    </el-form>
    <div class="common-cover-div"></div>
    <div class="operation-and-table__container">
      <div class="btns__container">
        <el-button size="mini" type="primary" class="plr28" @click="handleDelete" v-if="hasRole['YSZZSC']">删除
        </el-button>
         <span>金额：{{ totalInMoney}}</span>
      </div>
      <div class="table__container">
        <el-table v-loading="tableLoading" :data="list" height="100%" border style="width: 100%"
          @sort-change="handleSortChange"
          @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="40"></el-table-column>
          <el-table-column type="index" label="序号" width="80"></el-table-column>
          <el-table-column show-overflow-tooltip prop="typeName" label="应收类型" width="80"></el-table-column>
          <el-table-column show-overflow-tooltip prop="propertyUnitName" label="客户名称" width="200"></el-table-column>
          <el-table-column show-overflow-tooltip prop="inMoney" label="应收总金额" width="100" sortable="custom"></el-table-column>
          <el-table-column show-overflow-tooltip prop="receiveMoney" label="已收金额" width="100" sortable="custom"></el-table-column>
          <el-table-column show-overflow-tooltip prop="notReceiveMoney" label="未收金额" width="100"></el-table-column>
          <el-table-column show-overflow-tooltip prop="invoiceMoney" label="开票金额" width="100"></el-table-column>
          <el-table-column show-overflow-tooltip prop="reminderAmount" label="催缴次数" width="100"></el-table-column>
          <el-table-column show-overflow-tooltip prop="sourceCode" label="关联单号" width="100"></el-table-column>
          <el-table-column show-overflow-tooltip prop="liftInfo" label="相关电梯" width="100"></el-table-column>
          <el-table-column show-overflow-tooltip prop="repairUserName" label="维保人员" width="100"></el-table-column>
          <el-table-column show-overflow-tooltip prop="lastPassDate" label="最近收款时间" width="200" sortable="custom"></el-table-column>
          <el-table-column show-overflow-tooltip prop="passDate" label="确认收款时间" width="200" sortable="custom"></el-table-column>
          <el-table-column show-overflow-tooltip prop="remark" label="备注" width="200"></el-table-column>
          <el-table-column show-overflow-tooltip prop="createTime" label="创建时间" width="100"></el-table-column>
          <el-table-column show-overflow-tooltip prop="receiveNo" label="应收单据号" width="200" sortable="custom"></el-table-column>
          <el-table-column show-overflow-tooltip prop="billDate" label="单据日期" width="200"></el-table-column>
          <el-table-column label="操作" width="98px" fixed="right">
            <template slot-scope="scope">
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagenation__container">
        <div class="for-fff-bg">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex"
            :page-sizes="[25, 50, 100, 150, 200]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
            :total="total"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    getReceiveList,
    deleteReceive,
    passReceive,
    getReceiveTypeList,
    userSimpleList,
    getPropertyUnitSimpleList
  } from '@/api/Receive'
  export default {
    name: 'MaterialInfo',
    components: {},
    data() {
      return {
        form: {
          createTimeBetween: null,
          passTimeBetween: null,
          lastPassTimeBetween: null,
          payableNo: ""
        },
        tableLoading: false,
        list: [],
        userList: [],
        propertyUnitSimpleList: [],
        multipleSelection: [],
        pageIndex: 1,
        pageSize: 50,
        total: 0,
        addCauseVisible: false,
        editCauseVisible: false,
        checkDepartment: false,
        reminderListVisible: false,
        invoiceListVisible: false,
        collectionListVisible: false,
        causeDetail: {},
        statusFilterMonth: false,
        statusFilterOver: false,
        receiveTypeList: [],
        totalInMoney: 0
      }

    },
    computed: {
      hasRole: function() {
        return this.$store.getters['common/promise/getRole'](this.$route.path);
      }
    },
    created() {
      this.getListData();
      this.handleSpendingList();
      this.handleUserSimpleList();
      this.handlePropertyUnitSimpleList();
    },
    methods: {
      handleSortChange({
        column,
        prop,
        order
      }) {
        if (prop == 'inMoney') {
          prop = 'in_money'
        } else if (prop == 'receiveMoney') {
          prop = 'receive_money'
        } else if (prop == 'invoiceMoney') {
          prop = 'invoice_money'
        } else if (prop == 'overDayAmount') {
          prop = 'bill_date'
        } else if (prop == 'billDate') {
          prop = 'bill_date'
        } else if (prop == 'passDate') {
          prop = 'pass_date'
        } else if (prop == 'lastPassDate') {
          prop = 'last_pass_date'
        }
        if (order === 'ascending') {
          this.form.sortOrder = 'asc';
          this.form.sortField = prop
        } else if (order === 'descending') {
          this.form.sortOrder = 'desc';
          this.form.sortField = prop
        } else {
          this.form.sortField = '';
          this.form.sortOrder = '';
        }
        this.getListData();
      },
      async handlePropertyUnitSimpleList() {
        const res = await getPropertyUnitSimpleList({});
        if (res.code === 200) {
          this.propertyUnitSimpleList = res.data
        }
      },
      async handleUserSimpleList() {
        const res = await userSimpleList({});
        if (res.code === 200) {
          this.userList = res.data
        }
      },
      handleCollectionList(row) {
        this.causeDetail = row
        this.collectionListVisible = true
      },
      handleCollectionListVisibleConfirm() {
        this.collectionListVisible = false
        this.pageIndex = 1
        this.getListData()
      },
      handleInvoiceList(row) {
        this.causeDetail = row
        this.invoiceListVisible = true
      },
      handleInvoiceListVisibleConfirm() {
        this.invoiceListVisible = false
        this.pageIndex = 1
        this.getListData()
      },
      handleReminderList(row) {
        this.causeDetail = row
        this.reminderListVisible = true
      },
      handleReminderListVisibleConfirm() {
        this.reminderListVisible = false
        this.pageIndex = 1
        this.getListData()
      },
      async handleSpendingList() {
        const res = await getReceiveTypeList();
        if (res.code === 200) {
          this.receiveTypeList = res.data
        }
      },
      async getListData() {
        this.tableLoading = true
        const params = {
          pageIndex: this.pageIndex,
          pageSize: this.pageSize
        }
        for (let key in this.form) {
          if (this.form[key])
            params[key] = this.form[key]
        }

        if (this.form.createTimeBetween) {
          delete params.createTimeBetween;
          params.billDateEnd = this.form.createTimeBetween[1];
          params.billDateStart = this.form.createTimeBetween[0];
        }
        if (this.form.passTimeBetween) {
          delete params.passTimeBetween;
          params.passDateEnd = this.form.passTimeBetween[1];
          params.passDateStart = this.form.passTimeBetween[0];
        }
        if (this.form.lastPassTimeBetween) {
          delete params.lastPassTimeBetween;
          params.lastPassDateEnd = this.form.lastPassTimeBetween[1];
          params.lastPassDateStart = this.form.lastPassTimeBetween[0];
        }
        if (this.statusFilterOver) {
          params.statusFilterOver = 1
        } else {
          params.statusFilterOver = 0
        }
        if (this.statusFilterMonth) {
          params.statusFilterMonth = 1
        } else {
          params.statusFilterMonth = 0
        }
        params.passStatus = 10;
        const res = await getReceiveList(params)
        if (res.code === 200) {
          this.total = res.data.total
          this.list = res.data.list
        }
        this.tableLoading = false
      },
      handleSearch() {
        this.pageIndex = 1
        this.getListData()
      },
      handleRefresh() {
        for (let key in this.form) {
          if (Array.isArray(this.form[key])) {
            this.form[key] = []
          } else {
            this.form[key] = ''
          }
        }
        this.pageIndex = 1
        this.getListData()
      },
      handleSearchListData() {
        this.pageIndex = 1
        this.getListData()
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
        this.handleTotalInMoney();
      },
      handleTotalInMoney() {
        if (!this.multipleSelection.length) {
          return
        }
        const sum = this.multipleSelection.map(item => item.inMoney).reduce((acc, val) => acc + val, 0);
        this.totalInMoney = sum;
        console.log(sum); // 15
      },
      handleDeleteCause(row) {
        const idList = [row.id]
        this.deleteReceive(idList)
      },
      handleCheck(row) {
        this.causeDetail = row
        this.checkDepartment = true
      },
      handleEdit(row) {
        this.causeDetail = row
        this.editCauseVisible = true
      },
      handleDelete() {
        if (!this.multipleSelection.length) {
          this.$message.warning('请选择要删除的行')
          return
        }
        const idList = this.multipleSelection.map(item => item.id)
        this.deleteReceive(idList)
      },
      deleteReceive(idList) {
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          const res = await deleteReceive({
            idList
          })
          if (res.code === 200) {
            this.$message.success('删除成功')
            this.getListData()
          }
        }).catch((err) => {
          console.log(err)
        })

      },
      handleAdd() {
        this.addCauseVisible = true
      },
      exportCause() {
        const params = {
          pageIndex: this.pageIndex,
          pageSize: this.pageSize
        }
        for (let key in this.form) {
          if (this.form[key])
            params[key] = this.form[key]
        }
        exportCause(params)
      },
      handleSizeChange(val) {
        this.pageSize = val
        this.getListData()
      },
      handleCurrentChange(val) {
        this.pageIndex = val
        this.getListData()
      },

      handleAddCauseConfirm() {
        this.addCauseVisible = false
        this.pageIndex = 1
        this.getListData()
      },
      handleEditCauseConfirm() {
        this.editCauseVisible = false
        this.getListData()
      },
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/GeneralIedger/GeneralIedger.vue